import React from 'react';
import Page from '../../lib/page';
import HeroSectionNoLink from '../components/HeroSectionNoLink';
import HeroSection from '../components/HeroSection';

const isHeroModuleNoLink = Page.getIsHeroModuleNoLink();

const HeroModule = () => (
  isHeroModuleNoLink ? <HeroSectionNoLink /> : <HeroSection />
);

export default HeroModule;
